export const useTicketDropdownOptions = () => {
  const ticketCategoryOptions = [
    { id: 1, label: "Technical", value: "TECHNICAL" },
    { id: 2, label: "Academics", value: "ACADEMICS" },
    { id: 3, label: "HR", value: "HR" },
    { id: 4, label: "Marketing", value: "MARKETING" },
    { id: 5, label: "Admin", value: "ADMIN" },
  ];

  const priorityLevelOptions = [
    { id: 1, label: "Low", value: "LOW" },
    { id: 2, label: "Medium", value: "MEDIUM" },
    { id: 3, label: "High", value: "HIGH" },
  ];

  const ticketStatusOptions = [
    { id: 1, label: "New", value: "NEW" },
    { id: 2, label: "In Progress", value: "IN_PROGRESS" },
    { id: 3, label: "On Hold", value: "ON_HOLD" },
    { id: 4, label: "Resolved", value: "RESOLVED" },
    { id: 5, label: "Closed", value: "CLOSED" },
  ];

  return {
    ticketCategory: { options: ticketCategoryOptions },
    priorityLevel: { options: priorityLevelOptions },
    ticketStatus: { options: ticketStatusOptions },
  };
};
